

// import React, { useEffect, useState } from "react";
// import { Api } from "../Api/Api";


// const PaymentList = ({ payments }) => {
//   const [customers, setCustomers] = useState([]);

//   useEffect(() => {
  
//     fetch(`${Api}customers/list.php`)
//       .then((r) => r.json())
//       .then((d) => setCustomers(d.customers || []));
//   }, []);

//   const getCompletedWeeks = (givenDate) => {
//     const start = new Date(givenDate);
//     const today = new Date();

//     start.setHours(0, 0, 0, 0);
//     today.setHours(0, 0, 0, 0);

//     const diffDays = Math.floor((today - start) / 86400000);
//     return Math.floor(diffDays / 7);
//   };

//   const getDayName = (dateStr) => {
//     if (!dateStr) return "-";
//     return new Date(dateStr).toLocaleDateString("en-IN", {
//       weekday: "long",
//     });
//   };

//   const getWeekDisplayDate = (givenDate, weekNo, paidDate) => {
//     if (paidDate) {
//       return new Date(paidDate).toLocaleDateString("en-IN");
//     }
//     const d = new Date(givenDate);
//     d.setDate(d.getDate() + weekNo * 7);
//     return d.toLocaleDateString("en-IN");
//   };

//   return (
//     <div className="overflow-x-auto">
//       <table className="min-w-full border-collapse text-sm">
//         <thead className="bg-gray-100">
//           <tr>
//             <th className="border px-2">S.No</th>
//             <th className="border px-2">Customer Code</th>
//             <th className="border px-2">Customer</th>
//             <th className="border px-2">Loan Date</th>
//             <th className="border px-2">Day</th>
//             <th className="border px-2">Week Status</th>
//             <th className="border px-2">Pending</th>
//             <th className="border px-2">Last Payment</th>
//           </tr>
//         </thead>

//         <tbody>
//           {customers
//             .filter((c) => c.status === "Active")
//             .map((c, index) => {
//               const weekly = Number(c.weekly_interest_amount || 0);
//               const completedWeeks = getCompletedWeeks(c.given_date);

//               const customerPayments = payments.filter(
//                 (p) => Number(p.customer_id) === Number(c.id),
//               );

//               const lastPayment = customerPayments.length
//                 ? [...customerPayments].sort(
//                     (a, b) =>
//                       new Date(b.payment_date) - new Date(a.payment_date),
//                   )[0]
//                 : null;

//               const weekMap = {};
//               const weekPaymentDate = {};

//               customerPayments.forEach((p) => {
//                 const w = Number(p.week_number);
//                 weekMap[w] = (weekMap[w] || 0) + Number(p.paid_amount);

//                 if (
//                   !weekPaymentDate[w] ||
//                   new Date(p.payment_date) > new Date(weekPaymentDate[w])
//                 ) {
//                   weekPaymentDate[w] = p.payment_date;
//                 }
//               });

//               const maxPaidWeek = Math.max(
//                 0,
//                 ...Object.keys(weekMap).map(Number),
//               );
//               const maxWeekToShow = Math.max(
//                 completedWeeks + 1,
//                 maxPaidWeek + 1,
//               );
//               const nextComingWeek = Math.max(
//                 completedWeeks + 1,
//                 maxPaidWeek + 1,
//               );

//               // 🔥🔥🔥 FIXED PENDING CALCULATION 🔥🔥🔥
//               const totalDue = completedWeeks * weekly;

//               const totalPaid = customerPayments.reduce(
//                 (sum, p) => sum + Number(p.paid_amount || 0),
//                 0,
//               );

//               const pending = Math.max(totalDue - totalPaid, 0);

//               return (
//                 <tr key={c.id}>
//                   <td className="border px-2 text-center">{index + 1}</td>
//                   <td className="border px-2">{c.customer_code}</td>
//                   <td className="border px-2 font-semibold">{c.name}</td>
//                   <td className="border px-2">{c.given_date}</td>
//                   <td className="border px-2 text-indigo-700">
//                     {getDayName(c.given_date)}
//                   </td>

//                   <td className="border px-2">
//                     <div className="flex overflow-x-auto max-w-[650px]">
//                       {Array.from({ length: maxWeekToShow }, (_, i) => {
//                         const w = i + 1;
//                         const paid = weekMap[w] || 0;
//                         const isPaid = paid > 0;
//                         const isUpcoming = w === nextComingWeek && !isPaid;

//                         return (
//                           <div
//                             key={w}
//                             className={`min-w-[95px] text-xs font-bold text-center border
//                             ${
//                               isPaid
//                                 ? "bg-green-100 text-green-700"
//                                 : isUpcoming
//                                   ? "bg-yellow-100 text-yellow-700"
//                                   : "bg-red-100 text-red-700"
//                             }`}
//                           >
//                             <div className="border-b bg-gray-200 text-[10px]">
//                               W{w}
//                               <div className="text-[9px]">
//                                 {getWeekDisplayDate(
//                                   c.given_date,
//                                   w,
//                                   weekPaymentDate[w],
//                                 )}
//                               </div>
//                             </div>
//                             <div className="py-2">₹{paid}</div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </td>

//                   <td className="border px-2 font-bold text-red-600">
//                     ₹{pending}
//                   </td>

//                   <td className="border px-2 text-xs">
//                     {lastPayment ? lastPayment.payment_date : "-"}
//                   </td>
//                 </tr>
//               );
//             })}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default PaymentList;


import React, { useEffect, useState, useMemo } from "react";
import { Api } from "../Api/Api";
import { useNavigate } from "react-router-dom";


const PaymentList = ({ payments }) => {

const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
const [types, setTypes] = useState([]);
const [search, setSearch] = useState("");
const [type, setType] = useState("all");
const [activePopup, setActivePopup] = useState(null);
// { customerId, week }

const [popupPos, setPopupPos] = useState({ x: 0, y: 0 });



  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
const role = currentUser?.role; // "admin" | "staff"



useEffect(() => {
  fetch(`${Api}customers/list.php`)
    .then((r) => r.json())
    .then((d) => setCustomers(d.customers || []));

  fetch(`${Api}customers/types/list.php`)
    .then((r) => r.json())
    .then((d) => setTypes(d.types || []));
}, []);


  const getCompletedWeeks = (givenDate) => {
    const start = new Date(givenDate);
    const today = new Date();

    start.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffDays = Math.floor((today - start) / 86400000);
    return Math.floor(diffDays / 7);
  };

  const getDayName = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("en-IN", {
      weekday: "long",
    });
  };

  const getWeekDisplayDate = (givenDate, weekNo, paidDate) => {
    if (paidDate) {
      return new Date(paidDate).toLocaleDateString("en-IN");
    }
    const d = new Date(givenDate);
    d.setDate(d.getDate() + weekNo * 7);
    return d.toLocaleDateString("en-IN");
  };

  // 🔍 ACTIVE + SEARCH FILTER
const filteredCustomers = useMemo(() => {
  const q = search.toLowerCase();

  return customers.filter((c) => {
    if (c.status !== "Active") return false;

    const matchesSearch =
      !search ||
      c.name?.toLowerCase().includes(q) ||
      c.customer_code?.toLowerCase().includes(q);

    const matchesType = type === "all" || c.type === type;

    return matchesSearch && matchesType;
  });
}, [customers, search, type]);


const formatDateDMY = (dateStr) => {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const isBetweenThisWeek = (dateStr) => {
  const d = new Date(dateStr);
  const now = new Date();

  // Start of week (Sunday)
  const weekStart = new Date(now);
  weekStart.setDate(now.getDate() - now.getDay());
  weekStart.setHours(0, 0, 0, 0);

  // End of week (Saturday 23:59:59)
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekStart.getDate() + 6);
  weekEnd.setHours(23, 59, 59, 999);

  return d >= weekStart && d <= weekEnd;
};

  const btnBase =
    "px-3 py-1.5 rounded-md text-xs font-bold transition-all duration-200 shadow-sm border";
  const btnView = `${btnBase} bg-white text-indigo-600 border-indigo-100 hover:bg-indigo-600 hover:text-white`;
  const btnEdit = `${btnBase} bg-white text-amber-600 border-amber-100 hover:bg-amber-600 hover:text-white`;
  const btnDelete = `${btnBase} bg-white text-red-600 border-red-100 hover:bg-red-600 hover:text-white`;

  return (
    <div className="space-y-4">
      {/* 🔍 Search Bar */}
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 px-2">
        {/* 🔍 Search */}
        <input
          type="text"
          placeholder="Search by Customer Name or Code..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full sm:max-w-md px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500 focus:outline-none"
        />

        {/* 🔽 Type Filter */}
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm font-bold bg-white"
        >
          <option value="all">All Types</option>
          {types.map((t) => (
            <option key={t.id} value={t.type_name}>
              {t.type_name}
            </option>
          ))}
        </select>

        <span className="text-sm text-gray-500 font-medium">
          {filteredCustomers.length} results
        </span>
      </div>

      {/* <div className="overflow-x-auto"> */}
      <div className="overflow-x-auto overflow-y-auto max-h-[70vh] border rounded-lg shadow">
        <table className="min-w-full border-collapse text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-2">S.No</th>
              <th className="border px-2">Added By</th>
              <th className="border px-2">Customer Code</th>
              <th className="border px-2">Customer</th>
              <th className="border px-2">Loan Date</th>
              <th className="border px-2">Day</th>
               <th className="border px-2">Loan Amount</th>
              <th className="border px-2">Week Status</th>
              <th className="border px-2">Total Collection</th>
              <th className="border px-2">Pending</th>
              <th className="border px-2">Last Payment</th>
              <th className="border px-2">Action </th>
              
            </tr>
          </thead>

          <tbody>
            {filteredCustomers.length === 0 ? (
              <tr>
                <td
                  colSpan={8}
                  className="text-center py-10 text-gray-400 italic"
                >
                  No matching active customers
                </td>
              </tr>
            ) : (
              filteredCustomers.map((c, index) => {
                const weekly = Number(c.weekly_interest_amount || 0);
                const completedWeeks = getCompletedWeeks(c.given_date);

                const customerPayments = payments.filter(
                  (p) => Number(p.customer_id) === Number(c.id),
                );

                const lastPayment = customerPayments.length
                  ? [...customerPayments].sort(
                      (a, b) =>
                        new Date(b.payment_date) - new Date(a.payment_date),
                    )[0]
                  : null;

                const weekMap = {};
                const weekPaymentDate = {};

                customerPayments.forEach((p) => {
                  const w = Number(p.week_number);
                  weekMap[w] = (weekMap[w] || 0) + Number(p.paid_amount);

                  if (
                    !weekPaymentDate[w] ||
                    new Date(p.payment_date) > new Date(weekPaymentDate[w])
                  ) {
                    weekPaymentDate[w] = p.payment_date;
                  }
                });

                const maxPaidWeek = Math.max(
                  0,
                  ...Object.keys(weekMap).map(Number),
                );

                const maxWeekToShow = Math.max(
                  completedWeeks + 1,
                  maxPaidWeek + 1,
                );

                const nextComingWeek = maxWeekToShow;

                const totalDue = completedWeeks * weekly;
                const totalPaid = customerPayments.reduce(
                  (sum, p) => sum + Number(p.paid_amount || 0),
                  0,
                );
                const pending = Math.max(totalDue - totalPaid, 0);

                return (
                  <tr key={c.id}>
                    <td className="border px-2 text-center">{index + 1}</td>
                    <td className="border px-2 text-xs font-semibold text-indigo-700">
  {lastPayment?.created_by || "-"}
</td>

                    <td className="border px-2">{c.customer_code}</td>
                    <td className="border px-2 font-semibold">{c.name}</td>
                    <td className="border px-2">
                      {formatDateDMY(c.given_date)}
                    </td>

                    <td className="border px-2 text-indigo-700">
                      {getDayName(c.given_date)}
                    </td>

                    <td className="border px-2 text-indigo-700">
  {Number(c.investment_amount).toFixed(0)}
</td>

                    
                    

                    <td className="border px-2">
                      <div className="flex overflow-x-auto max-w-[650px]">
                        {Array.from({ length: maxWeekToShow }, (_, i) => {
                          const w = i + 1;
                          const paid = weekMap[w] || 0;
                          const isPaid = paid > 0;
                          const isUpcoming = w === nextComingWeek && !isPaid;

                          return (
                           
                            <div
  key={w}
  className={`relative min-w-[95px] text-xs font-bold text-center border cursor-pointer
    ${
      isPaid
        ? "bg-green-500 text-green-1200"
        : isUpcoming
          ? "bg-yellow-500 text-yellow-1200"
          : "bg-red-500 text-red-1200"
    }`}
 onClick={(e) => {
  setPopupPos({ x: e.clientX, y: e.clientY });
  setActivePopup(
    activePopup?.customerId === c.id && activePopup?.week === w
      ? null
      : { customerId: c.id, week: w }
  );
}}

>
  <div className="border-b bg-gray-200 text-[10px]">
    W{w}
    <div className="text-[9px]">
      {getWeekDisplayDate(c.given_date, w, weekPaymentDate[w])}
    </div>
  </div>

  <div className="py-2">₹{paid}</div>

 {activePopup?.customerId === c.id &&
  activePopup?.week === w && (
    <div
      className="fixed z-[9999] bg-black text-white text-[11px]
                 px-2 py-1 rounded shadow"
      style={{
        top: `${window.event?.clientY - 40}px`,
        left: `${window.event?.clientX}px`,
      }}
    >
      {c.name}
    </div>
)}

</div>

                          );
                        })}
                      </div>
                    </td>

<td className="border px-2 font-bold text-green-700 text-right">
  ₹{totalPaid}
</td>
                    <td className="border px-2 font-bold text-red-600">
                      ₹{pending}
                    </td>

                    {/* <td className="border px-2 text-xs">
                      {lastPayment ? lastPayment.payment_date : "-"}
                    </td> */}

                    <td className="border px-2 text-xs">
  {lastPayment ? formatDateDMY(lastPayment.payment_date) : "-"}
</td>


<td> <button
  onClick={() =>
    navigate(
      role === "admin"
        ? `/admin/payments/${c.id}`
        : `/staff/payments/${c.id}`
    )
  }
  className={btnView}
>
  View
</button>
  </td>

                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PaymentList;

